import { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';
import { useI18n } from '../../context/useI18n';

/**
 * Lectura sola Training↔FOOD — oculto en UX (v8.97: Food = foodplan.tech).
 * Implementación legacy conservada como `SharedProgressSnapshotLegacy`.
 */
export default function SharedProgressSnapshot() {
  return null;
}

/** @deprecated Conservado; no montar en UI. */
export function SharedProgressSnapshotLegacy({ onOpenMeasures, onOpenWellness, refreshKey = 0 }) {
  const { t } = useI18n();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get('/training/sync/food/snapshot');
      setData(r.data?.data || null);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load, refreshKey]);

  if (loading) {
    return (
      <div className="card p-4 animate-pulse space-y-2">
        <div className="h-4 bg-stone-200 rounded w-1/3" />
        <div className="h-8 bg-stone-200 rounded w-1/2" />
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="card p-4 space-y-3 text-sm text-stone-800">
      <p className="font-semibold text-stone-900">
        {t('mi_progreso.shared_snapshot', 'Resumen corporal')}
      </p>
      {data.weight != null ? (
        <p>
          {t('mi_progreso.last_weight', 'Último peso')}: <strong>{data.weight}</strong> kg
          {data.weight_source ? (
            <span className="text-stone-500 text-xs ml-1">
              ({data.weight_source === 'food' ? 'FOOD' : 'Training'})
            </span>
          ) : null}
        </p>
      ) : null}
      {data.food_bridge_error ? (
        <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-2">
          {t('mi_progreso.food_bridge_warn', 'No se pudo consultar FOOD ahora')} ({data.food_bridge_error}).
        </p>
      ) : null}
      <div className="flex flex-wrap gap-2">
        {onOpenMeasures ? (
          <button type="button" className="btn-secondary text-xs" onClick={onOpenMeasures}>
            {t('mi_progreso.open_measures', 'Medidas')}
          </button>
        ) : null}
        {onOpenWellness ? (
          <button type="button" className="btn-secondary text-xs" onClick={onOpenWellness}>
            {t('mi_progreso.open_wellness', 'Bienestar')}
          </button>
        ) : null}
      </div>
    </div>
  );
}
